import { render, staticRenderFns } from "./BannerInformationBox.vue?vue&type=template&id=760e819f&scoped=true&"
import script from "./BannerInformationBox.vue?vue&type=script&lang=ts&"
export * from "./BannerInformationBox.vue?vue&type=script&lang=ts&"
import style0 from "./BannerInformationBox.vue?vue&type=style&index=0&id=760e819f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760e819f",
  null
  
)

export default component.exports